export type RecencyTone = "green" | "blue" | "orange" | "grey";

export interface RecencyInfo {
    tone: RecencyTone;
    i18nKey: string;
    count?: number;
}

/** "How long ago" bucketing for a chip shown next to an absolute timestamp — calendar-day
 *  difference (so "yesterday" means the previous calendar day, not a rolling 24h window).
 *  Coarser than admin/src/utils/recency.ts's sub-day minute/hour tiers on purpose: these are
 *  sync/log timestamps ("when did this happen"), not "is this user online right now". */
export function getRecency(timestamp: number | string | Date, now: number = Date.now()): RecencyInfo {
    const t = timestamp instanceof Date ? timestamp.getTime()
        : typeof timestamp === "string" ? new Date(timestamp).getTime()
        : timestamp;

    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);
    const startOfEventDay = new Date(t);
    startOfEventDay.setHours(0, 0, 0, 0);
    const dayDiff = Math.round((startOfToday.getTime() - startOfEventDay.getTime()) / 86400000);

    if (dayDiff <= 0) return { tone: "green", i18nKey: "common.recency.today" };
    if (dayDiff === 1) return { tone: "blue", i18nKey: "common.recency.yesterday" };
    if (dayDiff < 7) return { tone: "blue", i18nKey: "common.recency.daysAgo", count: dayDiff };
    if (dayDiff < 28) return { tone: "orange", i18nKey: "common.recency.weeksAgo", count: Math.round(dayDiff / 7) };

    const months = Math.round(dayDiff / 30);
    if (months <= 12) return { tone: "grey", i18nKey: "common.recency.monthsAgo", count: months };

    return { tone: "grey", i18nKey: "common.recency.yearsAgo", count: Math.round(dayDiff / 365) };
}
